import { createContext, useContext } from 'react'

interface ViewContextValue {
  id: string
  context: unknown
  /** History entry key — identity for per-entry persisted state (scroll, drafts). */
  entryKey: number
  /** Label of the section/view that opened this one. */
  sourceLabel?: string
}

export const ViewContext = createContext<ViewContextValue | null>(null)

export function useViewContext<T = unknown>() {
  const context = useContext(ViewContext)
  if (!context) {
    throw new Error('useViewContext must be used within a View rendered by the view router')
  }
  return context as ViewContextValue & { context: T }
}

export const ViewEntranceSettledContext = createContext(true)

/**
 * True once the view's transition has settled (immediately for a view that
 * skipped the entrance). Views gate expensive body content on this so the
 * mount cost doesn't land on the animation's frames and drop them.
 */
export function useViewEntranceSettled(): boolean {
  return useContext(ViewEntranceSettledContext)
}
